import {OccSecurityConfig, RecaptchaV2Size} from '@vista/omnichannel-components-ui'

import { NestedPartial } from '@vista/omnichannel-components-domain'
import { Security } from '../../types'

interface SecurityConfigDataProps {
    security?: NestedPartial<Security>
}

export function getSecurityConfigData(props:SecurityConfigDataProps):OccSecurityConfig {
    const {security} = props

    const returnCaptcha = {
        captcha: {
            siteKey: security?.captcha?.siteKey,
            size: security.captcha.size ? RecaptchaV2Size[security.captcha.size] : undefined
        }
    }
    
    return returnCaptcha
}
